
export default {
  props: ["value"],
};
